class JumpNavigation {
  constructor($main) {
    if (!this.initDomElements($main)) return false;
    this.breakPoint = 1023;
    this.boundToggle = this.onToggleClick.bind(this);
    this.boundResize = this.onResize.bind(this);
    this.applyMode();
    $(window).on('resize', this.boundResize);
  }

  initDomElements($main) {
    this.dom = {};
    this.dom.main = $main;
    if (!this.dom.main || this.dom.main.length < 1) return false;
    this.dom.inside = this.dom.main.find('.jump-navigation__inside');
    this.dom.toggle = this.dom.main.find('.jump-navigation__toggle');
    this.dom.list = this.dom.main.find('.jump-navigation__list');
    return true;
  }

  isDesktop() {
    return window.matchMedia(`(min-width: ${this.breakPoint + 1}px)`).matches || $(window).width() > this.breakPoint;
  }

  applyMode() {
    if (this.isDesktop()) {
      this.enableDesktopMode();
    } else {
      this.enableMobileMode();
    }
  }

  enableDesktopMode() {
    // remove mobile bindings
    this.dom.toggle.off('click', this.boundToggle);
    // ensure list is visible and mark all-visible
    this.dom.main.addClass('jump-navigation--all-visible');
    this.dom.list.stop(true, true).show();
    this.dom.toggle.attr('aria-expanded', 'true');
  }

  enableMobileMode() {
    // remove desktop marker
    this.dom.main.removeClass('jump-navigation--all-visible');
    // bind toggle if not already
    this.dom.toggle.off('click', this.boundToggle).on('click', this.boundToggle);
    // initial state according to aria-expanded
    const expanded = this.dom.toggle.attr('aria-expanded') === 'true';
    if (expanded) {
      this.dom.list.show();
    } else {
      this.dom.list.hide();
    }
  }

  onToggleClick(e) {
    e.preventDefault();
    const expanded = this.dom.toggle.attr('aria-expanded') === 'true';
    const newState = !expanded;
    this.dom.toggle.attr('aria-expanded', newState ? 'true' : 'false');
    if (newState) {
      this.dom.list.stop(true, true).slideDown(150);
    } else {
      this.dom.list.stop(true, true).slideUp(150);
    }
  }

  onResize() {
    const wasDesktop = this.dom.main.hasClass('jump-navigation--all-visible');
    const nowDesktop = this.isDesktop();
    if (wasDesktop !== nowDesktop) {
      this.applyMode();
    }
  }
}

export default JumpNavigation;
